var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modal",class:("mfp-hide " + (_vm.modalStyle.class)),attrs:{"id":_vm.modalStyle.id}},[_c('div',{staticClass:"popin",style:({ maxHeight: _vm.modalHeight })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }